//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import eventHub from 'utils/eventHub'
export default {
  data () {
    return {
      imgData1: [
        {'src': require('../../assets/fujiFilm/1.jpg')},
        {'src': require('../../assets/fujiFilm/2.jpg')},
        {'src': require('../../assets/fujiFilm/3.jpg')},
        {'src': require('../../assets/fujiFilm/4.jpg')},
        {'src': require('../../assets/fujiFilm/5.jpg')}
      ],
      imgData2: [
        {'src': require('../../assets/fujiFilm/2_1.jpg')},
        {'src': require('../../assets/fujiFilm/2_2.jpg')},
        {'src': require('../../assets/fujiFilm/2_3.jpg')},
        {'src': require('../../assets/fujiFilm/2_4.jpg')},
        {'src': require('../../assets/fujiFilm/2_5.jpg')}
      ],
      jiGuang: true,
      fuShi: false,
      jiGuangPic: false,
      fuShiPic: false,
      selectedPic: '',
      downloadImg: window.location.origin + 'static/downloadImg/p1_03.jpg'
    }
  },
  components: {
  },
  methods: {
    tabClick (param) {
      this.jiGuang = param === 'jiGuang' && !this.jiGuangPic && !this.fuShiPic
      this.fuShi = param === 'fuShi' && !this.jiGuangPic && !this.fuShiPic
    },
    previewInfo () {
      // this.previewInfoUrl = window.location.origin + '/#/' + 'fujiFilm'
      if (this.jiGuang) {
        this.selectedPic = 'jiGuang'
        this.$router.push({name: 'blankPage', params: {selectedPic: this.selectedPic}})
      } else {
        this.selectedPic = 'fuShi'
        this.$router.push({name: 'blankPage', params: {selectedPic: this.selectedPic}})
      }
    }
  },
  created () {
    if (this.$route.params.selectedPic === 'jiGuang') {
      this.jiGuang = false
      this.fuShi = false
      this.jiGuangPic = true
      this.fuShiPic = false
    } else if (this.$route.params.selectedPic === 'fuShi') {
      this.jiGuang = false
      this.fuShi = false
      this.jiGuangPic = false
      this.fuShiPic = true
    } else {
      this.jiGuang = true
      this.fuShi = false
      this.jiGuangPic = false
      this.fuShiPic = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/fujiFilm/index.vue